module.exports = __webpack_public_path__ + "static/media/amporto.19096295.webp";